
import {VEHICLE_INACTIVE} from "@/config/tackingConfig";

export default class Vehicle {

    constructor(
        id,
        fleetId,
        driverId,
        manufacturer,
        registrationNumber,
        hexColor,
        model,
        engineSize,
        fuelType,
        type,
        createdOn,
        createdBy,
        trackingDeviceId,
        trackingHardwareId,
        mediaDeviceId,
        mediaHardwareId,
        driverName,
        fleetName,
        organizationName,
        isFavourite,
        firstReported,
        canRequestImage,
        canRequestVideo,
        canRebootTrackingDevice,
        canRebootMediaDevice,
        canFormatTrackingDevice,
        canFormatMediaDevice,
        hasHadDevice,
        status = VEHICLE_INACTIVE,
        vehicleTracking = null,
        devices = [],
        activeDevice = null,
        isVisible = true,
    ) {
        this.id = id
        this.fleetId = fleetId
        this.driverId = driverId
        this.manufacturer = manufacturer
        this.registrationNumber = registrationNumber
        this.hexColor = hexColor
        this.model = model
        this.engineSize = engineSize
        this.fuelType = fuelType
        this.type = type
        this.createdOn = createdOn
        this.createdBy = createdBy
        this.trackingDeviceId = trackingDeviceId
        this.trackingHardwareId = trackingHardwareId
        this.mediaDeviceId = mediaDeviceId
        this.mediaHardwareId = mediaHardwareId
        this.driverName = driverName
        this.fleetName = fleetName
        this.organizationName = organizationName
        this.isFavourite = isFavourite
        this.firstReported = firstReported
        this.canRequestImage = canRequestImage
        this.canRequestVideo = canRequestVideo
        this.canRebootTrackingDevice = canRebootTrackingDevice
        this.canRebootMediaDevice = canRebootMediaDevice
        this.canFormatTrackingDevice = canFormatTrackingDevice
        this.canFormatMediaDevice = canFormatMediaDevice
        this.hasHadDevice = hasHadDevice
        this.status = status
        this.vehicleTracking = vehicleTracking
        this.devices = devices
        this.activeDevice = activeDevice
        this.isVisible = isVisible
    }

}
